import { Formik, FormikConfig } from 'formik';
import Nav from './Nav';
import Basic from './Basic';
import { FV } from './share';
import { regionLangMap } from '../share';
import { Button, Form, message } from 'antd';
import styled from '@emotion/styled';
import Region from './Region';
import { ConceptProvider } from '../WhatsAppEditor/ContentEditor';
import { useUpdateDirty } from 'views/Multitab/state';
import { findFirstError } from 'views/Aide/Scenario/PolicyForm';
import { useTranslate, T } from '@tolgee/react';
import { useState } from 'react';

function TemplateForm({
  mode,
  templateList,
  onCancel,
  ...otherProps
}: FormikConfig<FV> & {
  mode: string;
  templateList: Aide.WhatsAppTemplateGroup[];
  onCancel: () => void;
}) {
  const { t } = useTranslate();

  const [key, setKey] = useState(0);

  return (
    <Formik enableReinitialize validateOnMount {...otherProps}>
      {({ values, dirty, isSubmitting, handleSubmit }) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useUpdateDirty(dirty);

        const regions = Object.keys(regionLangMap).filter((region) => {
          return values.regionTemplateMap[region] && !values.regionTemplateMap[region].cancelled;
        });

        return (
          <Container>
            <header>
              <h3>
                {
                  {
                    create: t('新增模版'),
                    edit: t('编辑模版'),
                    copy: t('复制模版'),
                  }[mode]
                }
              </h3>
              <div>
                <T
                  keyName="whatsappTips"
                  params={{
                    a: (
                      <Button
                        type="link"
                        href="https://www.facebook.com/business/help/766346674749731"
                        target="_blank"
                      />
                    ),
                    b: (
                      <Button
                        type="link"
                        href="https://www.whatsapp.com/legal/business-policy/?fbclid=IwAR1jLRqG2MmfXVpoC8OxG2zTl5Ub96hEm-Kq7ucQ9K5dNB8GDFaAupD530Q"
                        target="_blank"
                      />
                    ),
                  }}
                />
              </div>
            </header>
            <Form layout="vertical">
              <aside>
                <Nav />
              </aside>
              <section>
                <Basic mode={mode} templateList={templateList} />
                <ConceptProvider key={key} templateList={templateList}>
                  {regions.map((region, index) => {
                    return (
                      <Region
                        region={region}
                        showCopy={index === 0 && regions.length > 1}
                        onCopy={() => setKey(key + 1)}
                      />
                    );
                  })}
                </ConceptProvider>
                <footer>
                  <Button
                    type="primary"
                    loading={isSubmitting}
                    onClick={(e) => {
                      handleSubmit();
                      setTimeout(() => {
                        const firstError = findFirstError(e);
                        if (firstError) {
                          message.error(firstError);
                        }
                      });
                    }}
                  >
                    {t('提交审核')}
                  </Button>
                  <Button onClick={() => onCancel()}>{t('取消')}</Button>
                </footer>
              </section>
            </Form>
          </Container>
        );
      }}
    </Formik>
  );
}

const Container = styled.div`
  > header {
    display: flex;
    align-items: center;
    height: 56px;
    margin-bottom: 8px;
    padding: 0 24px;
    background: #fff;
    > h3 {
      flex: 0 0 auto;
      margin-bottom: 0;
      margin-right: 8px;
    }
    > div {
      flex: 1 0 0;
    }
  }
  > form {
    display: flex;
    align-items: flex-start;
    > aside {
      flex: 0 0 auto;
      position: sticky;
      top: 0;
      margin-right: 16px;
      background: #fff;
    }
    > section {
      flex: 1 0 0;
      overflow: hidden;
      > div {
        padding: 24px;
        margin-bottom: 16px;
        background: #fff;
        > h4 {
          position: relative;
          text-indent: 14px;
          &::before {
            content: '';
            display: inline-block;
            position: absolute;
            top: 4px;
            left: 0;
            width: 4px;
            height: 14px;
            background: var(--ant-primary-color);
          }
        }
      }
      > footer {
        display: flex;
        align-items: center;
        position: fixed;
        bottom: 0;
        width: -webkit-fill-available;
        height: 56px;
        padding: 0 16px;
        margin-right: 22px;
        box-shadow: 0 -2px 8px 0 #a7b2cc1a, inset 0 1px 0 0 #f0f2f5;
        background: #fff;
        z-index: 1;
        > * + * {
          margin-left: 12px;
        }
      }
    }
  }
`;

export default TemplateForm;
